import { z } from 'zod'

const documentCategorySchema = z.object({
  id: z.number(),
  labels: z.object({
    fi: z.string(),
    sv: z.string(),
    en: z.string(),
  }),
})

export const coreDocumentSchema = z.object({
  id: z.number(),
  uuid: z.string().uuid(),
  name: z.string(),
  documentCategory: documentCategorySchema.nullable(),
  documentType: z.string(),
  linkUrl: z.string().nullable().optional(),
})

export const coreDocumentResponseSchema = z.array(coreDocumentSchema)

const documentSchema = coreDocumentSchema.omit({ documentCategory: true })

export const documentResponseSchema = z.array(
  z.object({
    category: documentCategorySchema,
    documents: z.array(documentSchema),
  })
)

export type TCoreDocumentResponse = z.infer<typeof coreDocumentResponseSchema>

export type TDocument = z.infer<typeof documentSchema>
export type TDocumentCategory = z.infer<typeof documentCategorySchema>
export type TDocumentResponse = z.infer<typeof documentResponseSchema>
